import { useTranslation } from "react-i18next"
import { Button } from "@nexus/ui"

export function IndustryPendingActions({
  disabled,
  isBusy,
  onReject,
  onAccept,
}: {
  disabled: boolean
  isBusy: boolean
  onReject: () => void
  onAccept: () => void
}) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button
        type="button"
        variant="outline"
        size="lg"
        className="min-w-0 flex-1"
        disabled={disabled}
        iconStart="x"
        onClick={onReject}
      >
        {t("personas.onboarding.industry.reject", "Reject")}
      </Button>
      <Button
        type="button"
        size="lg"
        className="min-w-0 flex-1 bg-[var(--competitor)] text-white hover:bg-[var(--competitor)]/90 active:bg-[var(--competitor)]/80"
        disabled={disabled || isBusy}
        iconStart="plus"
        onClick={onAccept}
      >
        {t("personas.onboarding.industry.accept", "Add persona")}
      </Button>
    </div>
  )
}
